import { ForwardedRef, RefCallback } from "react";

export default function combineRefs<T>(
  refA: ForwardedRef<T> | null | undefined,
  refB: ForwardedRef<T> | null | undefined,
): RefCallback<T> {
  return function refCb(component: T) {
    if (typeof refA === "function") {
      refA(component);
    } else if (refA) {
      // eslint-disable-next-line no-param-reassign
      refA.current = component;
    }

    if (typeof refB === "function") {
      refB(component);
    } else if (refB) {
      // eslint-disable-next-line no-param-reassign
      refB.current = component;
    }
  };
}
